import { atom } from "@mongez/react-atom";
import type { ProductDetails } from "core/catalog";

export const productAtom: any = atom<ProductDetails>({
  key: "product",
  default: {},
});
